export default "__VITE_ASSET__OX4HespP__"